// src/web/client/src/pages/legacyRoutes.jsx
//
// Redirects from the routes the app had before the six-page menu (UX brief,
// Phase B) to their new homes. The query string is KEPT: an embedded entry
// lands on /dashboard?shop&host&id_token… (routes/auth.js), and App Bridge /
// the shop resolver read those params from the URL. A `tab` is added so the
// page opens on the section the old screen became.
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export function legacyTarget(to, tab, search, param = 'tab') {
  const params = new URLSearchParams(search || '');
  if (tab) params.set(param, tab);
  const q = params.toString();
  return q ? `${to}?${q}` : to;
}

export function LegacyRedirect({ to, tab, param }) {
  const location = useLocation();
  return <Navigate to={legacyTarget(to, tab, location.search, param)} replace />;
}

// /pro-tools?tab=… — each old tool has a different new home.
export const PRO_TOOLS_TARGETS = {
  vip: ['/customers', 'vip'],
  // Sentiment was removed in B3 (it was not sentiment — see pages/Results.jsx); its old link lands on Results.
  sentiment: ['/results'],
  timing: ['/automations', 'timing'],
  'ab-testing': ['/automations', 'ab'],
};
export function ProToolsRedirect() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [to, tab, param] = PRO_TOOLS_TARGETS[params.get('tab')] || PRO_TOOLS_TARGETS.timing;
  params.delete('tab');
  return <Navigate to={legacyTarget(to, tab, params.toString(), param)} replace />;
}

// /analytics?tab=… — Analytics' old inner tabs became the Results sections.
export const ANALYTICS_SECTIONS = { overview: null, messages: 'emails', attribution: 'revenue', segments: 'segments' };
export function AnalyticsRedirect() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const section = ANALYTICS_SECTIONS[params.get('tab')] ?? null;
  params.delete('tab');
  return <Navigate to={legacyTarget('/results', section, params.toString(), 'section')} replace />;
}
